import React, { useState, useEffect } from 'react';
import ErrorMsgField from '../../../components/ErrorMsgField';
import Select from 'react-select';
import PropTypes from 'prop-types';
/* components */
import ModalPreviewItem from '../../../components/ModalPreviewItem';
/* utils */
import { customStyle, customThemes } from '../../../utils/select';
import sortable from '../../../utils/sortable';
import Preview from '../../Clients/Preview';

function Clients (props) {
  const { clientsData, data, setData } = props;
  const INITIAL_CLIENT = { _id: '', name: '' };
  const firstOption = {
    value: '',
    sortValue: '',
    label: 'Pesquisar'
  };
  const customFilter = (option, searchText) => {
    setSearchText(searchText);
    return !!option.data.label.toLowerCase().includes(searchText.toLowerCase());
  };
  const [searchText, setSearchText] = useState('');
  const [searchClient, setSearchClient] = useState('');
  const [client, setClient] = useState(INITIAL_CLIENT);
  const [clientOptions, setClientOptions] = useState([firstOption]);
  const [showModalPreviewItem, setShowModalPreviewItem] = useState(false);

  useEffect(() => {
    if (clientsData.length) {
      const options = clientsData
        .map(client => ({
          clientId: client._id,
          value: client.cpf ? client.cpf : client.cnpj,
          label: `${client.name} - ${client.cpf ? client.cpf : client.cnpj}`,
          sortValue: client.name
        }))
        .sort(sortable);
      options.unshift(firstOption);
      setClientOptions([...options]);
    }
  }, [clientsData, setClientOptions]);

  const handleChangeSearchClient = evt => {
    const { value } = evt;
    setSearchClient(value);
    const client = clientsData.find(
      client => client.cpf === value || client.cnpj === value
    );
    if (client) {
      setClient(client);
    } else {
      setClient(INITIAL_CLIENT);
    }
  };

  const handleClickAddClients = () => {
    const { clients } = data;
    if (client._id && !clients.includes(client._id)) {
      clients.push(client._id);
      setData({ ...data, clients });
      setSearchClient('');
      setClient(INITIAL_CLIENT);
    }
  };

  const handleClickRemoveClients = id => {
    const clients = data.clients.filter(clientId => clientId !== id);
    setData({ ...data, clients });
  };

  return (
    <React.Fragment>
      <ModalPreviewItem
        showModal={showModalPreviewItem}
        handleModalClose={() => setShowModalPreviewItem(false)}
        component={() => {
          return data.clients.map((clientId, index) => {
            return (
              <Preview
                key={index}
                data={clientsData.find(client => client._id === clientId)}
              />
            );
          });
        }}
      />
      <div className="row">
        <div className="col-sm-4">
          <div className="form-group">
            <div className="form-group form-inline mb-0">
              <label
                className="col-sm-12 d-inline p-0 mb-2"
                htmlFor="searchClient"
              >
                Nome, CPF ou CNPJ do Cliente
              </label>
              <Select
                className="col p-0"
                name="searchClient"
                onChange={handleChangeSearchClient}
                defaultValue={clientOptions[0]}
                value={clientOptions.find(
                  client => client.value === searchClient
                )}
                options={clientOptions.filter(
                  opt =>
                    (!data.clients.includes(opt.clientId) &&
                      opt.value !== searchText &&
                      searchText.length >= 4) ||
                    opt.value === ''
                )}
                isSearchable={true}
                theme={customThemes}
                styles={{
                  ...customStyle,
                  indicatorsContainer: () => ({ display: 'none' })
                }}
                filterOption={customFilter}
                noOptionsMessage={() => 'Nenhum registro até o momento'}
              />
            </div>
          </div>
        </div>
        <div className="col-sm-8">
          <div className="form-group form-inline mb-0">
            <label htmlFor="nameClient" className="w-100 d-inline-block mb-2">
              Nome do Cliente
            </label>
            <input
              type="text"
              id="nameClient"
              name="nameClient"
              className="form-control w-75"
              value={client.name}
              disabled={true}
            />
            <button
              type="button"
              className="btn btn-info rounded-0 w-25"
              title="Adicinar cliente na lista"
              disabled={!(client.name && !data.clients.includes(client._id))}
              onClick={handleClickAddClients}
            >
              <i className="fa fa-plus" />
            </button>
          </div>
          {data.clients.includes(client._id) && (
            <ErrorMsgField
              type="repeat"
              msg="Cliente pesquisado está na lista de membros"
            />
          )}
        </div>
        <div className="col-sm-12">
          <div className="form-group mt-2">
            <label>Clientes Envolvidos</label>
            {data.clients.length ? (
              data.clients.map((clientId, i) => {
                const client = clientsData.find(
                  client => client._id === clientId
                );
                return (
                  <div key={i}>
                    <span>
                      {client
                        ? `${client.name} - ${
                            client.cpf ? client.cpf : client.cnpj
                          }`
                        : 'Carregando...'}
                    </span>
                    {client && (
                      <div className="d-inline-block">
                        <button
                          className="btn btn-primary btn-sm ml-2 mb-1"
                          disabled={showModalPreviewItem}
                          onClick={() => setShowModalPreviewItem(true)}
                        >
                          <i className="fa fa-search" />
                        </button>
                        <button
                          className="btn btn-danger btn-sm ml-2 mb-1"
                          onClick={() => handleClickRemoveClients(client._id)}
                        >
                          <i className="fa fa-trash" />
                        </button>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div>
                <span className="text-danger">
                  * Nenhum cliente foi adicionado
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

Clients.propTypes = {
  clientsData: PropTypes.array,
  data: PropTypes.object,
  setData: PropTypes.func
};

export default Clients;
